// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"93":"contatti","559":"progetto","594":"about","717":"soluzioni","962":"store"}[chunkId] + "." + {"93":"dfeff1a7","559":"a9b3caaf","594":"5891e962","717":"9a1c8e11","962":"86cd67c2"}[chunkId] + ".js";
};